interface SampleDataStartState {
  isTestAccount: boolean;
  previewMode: boolean;
  sampleDataBusy: boolean;
  hasSampleStoreConnection: boolean;
}

/**
 * A private Test Account should behave like its chosen tools connected
 * successfully. Start its safe sample import as soon as the source review is
 * complete, but never restart an import that is already running or loaded.
 */
export function shouldAutoLoadTestSampleData(state: SampleDataStartState): boolean {
  return state.isTestAccount
    && !state.previewMode
    && !state.sampleDataBusy
    && !state.hasSampleStoreConnection;
}

export function hasActiveSampleDataJob(
  jobs: Array<{ jobType: string; status: string }> | undefined,
): boolean {
  return jobs?.some((job) => job.jobType === "seed_test_account"
    && (job.status === "queued" || job.status === "running")) ?? false;
}
